import { Link } from "react-router-dom";

export default function Breadcrumb({ items }) {
  // Don't render if no items
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  // Filter out null items
  const validItems = items.filter(item => item && item.name);

  if (validItems.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="breadcrumb-nav">
      <ol className="breadcrumb-list">
        {validItems.map((item, index) => {
          const isLast = index === validItems.length - 1;
          
          return (
            <li key={index} className="breadcrumb-item">
              {isLast ? (
                <span 
                  className="breadcrumb-current" 
                  aria-current="page"
                >
                  {item.name}
                </span>
              ) : (
                <>
                  <Link 
                    to={item.path || "/"} 
                    className="breadcrumb-link"
                  >
                    {item.name}
                  </Link>
                  <span className="breadcrumb-separator" aria-hidden="true">
                    /
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
